import Link from '@mui/material/Link';
import { Box, Stack, Typography } from '@mui/material';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  contactDetailHref?: (id: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellSource({ row, contactDetailHref }: Props) {
  const contactId = (row as any)?.parties?.from?.contactId;
  const fromNumber = (row as any)?.parties?.from?.number;
  const toNumber = (row as any)?.parties?.to?.number;

  return (
    <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
      <Stack sx={{ typography: 'body2', flex: '1 1 auto', alignItems: 'flex-start' }}>
        <Link
          component={RouterLink}
          href={contactId && contactDetailHref ? contactDetailHref(contactId) : '#'}
          color="inherit"
          underline={contactId ? 'hover' : 'none'}
          sx={{
            cursor: contactId ? 'pointer' : 'default',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              color: 'primary.main',
              transform: contactId ? 'translateX(4px)' : 'none',
            },
          }}
        >
          {fromNumber && (
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {fromNumber}
            </Typography>
          )}
          {toNumber && (
            <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
              {toNumber}
            </Typography>
          )}
        </Link>
      </Stack>
    </Box>
  );
}
